export default __webpack_public_path__ + "assets/approved.c87685f8.svg";